import { widget } from 'lib/charting_library/charting_library.esm.js';
import Datafeed from './datafeed';
import { resolutions_reverse_template_s } from "./param"
import { LANGUAGE_LOCALSTORAGE_KEY } from "config/localStorage"
import {s} from "./socket"

const initKlineFun = (symbol="btc", period = "5m", width, height) => {
  // console.log("initKlineFun-symbol=", symbol)
  // console.log("initKlineFun-period=", period)
  // const socketInstance = new s("ws://10.234.67.155:9999/ws/ws");
  // console.log("socket=", socketInstance)
  // socketInstance.doOpen()
  // socketInstance.on('message', onMessage)
  // socketInstance.on('close', onClose)
  // const socketInstance_a = new s("ws://10.234.67.155:9999/ws/ws");
  // if (!socketInstance_a?.socket){
  //   socketInstance_a.doOpen()
  // }
  var widget_instance = new widget({
  // const widget_instance = new TradingView.widget({
    // symbol: "btcusdt", // default symbol
    symbol: symbol.toLowerCase()+"usdt", // default symbol
    // interval: '5', // default interval
    interval: resolutions_reverse_template_s[period], // default interval
    fullscreen: false, // displays the chart in the fullscreen mode
    container: 'tv_chart_container',
    datafeed: Datafeed,
    library_path: '/charting_library/',
    custom_css_url: 'custom-styles.css',
    loading_screen: {
      backgroundColor: "#1B2D4B",
      foregroundColor: "#3ADBFF"
    },
    locale: localStorage.getItem(LANGUAGE_LOCALSTORAGE_KEY) || "en", // zh, en
    debug: false,
    timezone: 'Asia/Shanghai',
    // theme: "Dark",
    autosize: true,
    // width,
    // height,
    disabled_features: [
      "use_localstorage_for_settings", // 禁用本地配置
      'header_symbol_search', // 头部搜索
      'header_compare',// 图表对比
      "header_saveload",// 保存图表、加载图表 按钮
      "timeframes_toolbar", // 
      "display_market_status", // 关闭 市场状态(开盘或收盘等)
      // "left_toolbar", // 关闭左侧工具栏
      // "hide_left_toolbar_by_default",
      "main_series_scale_menu", // 关闭 图表右下角的设置按钮
      "header_undo_redo", // 关闭 撤销、重置 按钮
    ],
    enabled_features: [
      // 'dont_show_boolean_study_arguments',
    ],
    overrides: {
      // "paneProperties.background": "#1B2D4B", // 画布背景颜色
      "paneProperties.background": "rgba(0,0,0,0)", // 画布背景颜色透明色
      "paneProperties.legendProperties.showSeriesTitle": false, // 隐藏左上角的币值名称
      // "paneProperties.legendProperties.color": "#0000",
      // "paneProperties.legendProperties.showSeriesOHLC": false,
      // "paneProperties.vertGridProperties.color": "#232639", // 垂直网格线颜色
      "paneProperties.vertGridProperties.color": "#25395F", // 垂直网格线颜色
      "paneProperties.horzGridProperties.color": "#25395F", // 水平网格线颜色
      "paneProperties.vertGridProperties.style": 1, // 设置垂直网格线为虚线
      "paneProperties.horzGridProperties.style": 1, // 设置水平网格线为虚线

      "paneProperties.crossHairProperties.style": 2, // 设置网格均线为虚线
      "scalesProperties.lineColor": "#00000000", // 坐标轴和刻度标签颜色
      "scalesProperties.textColor": "#ffffff", // 坐标轴和刻度标签颜色
      "paneProperties.topMargin": 10, // 边际（百分比）。 用于自动缩放。上边距，k线距离标题
      "paneProperties.bottomMargin": 0, // 边际（百分比）。 用于自动缩放。下边距，k线距离指标

      // K线图样式
      // "mainSeriesProperties.candleStyle.upColor": "#6ba583",
      // "mainSeriesProperties.candleStyle.downColor": "#d75442",
      "mainSeriesProperties.candleStyle.drawWick": true,
      "mainSeriesProperties.candleStyle.drawBorder": true,
      "mainSeriesProperties.candleStyle.borderColor": "#378658",
      // "mainSeriesProperties.candleStyle.borderUpColor": "#225437",
      // "mainSeriesProperties.candleStyle.borderDownColor": "#5b1a13",
      // "mainSeriesProperties.candleStyle.wickUpColor": 'rgba( 115, 115, 117, 1)',
      // "mainSeriesProperties.candleStyle.wickDownColor": 'rgba( 115, 115, 117, 1)',
      "mainSeriesProperties.candleStyle.barColorsOnPrevClose": false,

      "mainSeriesProperties.candleStyle.upColor": "#61E897", // 买入颜色
      "mainSeriesProperties.candleStyle.borderUpColor": "#61E897", // 买入边框颜色
      "mainSeriesProperties.candleStyle.wickUpColor": '#61E897', // 买入线条颜色
      "mainSeriesProperties.candleStyle.downColor": "#FF6755", // 卖出颜色
      "mainSeriesProperties.candleStyle.borderDownColor": "#FF6755", // 卖出边框颜色
      "mainSeriesProperties.candleStyle.wickDownColor": '#FF6755', // 卖出线条颜色

    }
  });
  // console.log("initKlineFun-widget_instance=", widget_instance)
  return widget_instance
}

export default initKlineFun